/**
 * src/utils/network.js
 * Utilidades de red sin dependencias de Firebase
 */

/**
 * Obtener estado de conexión del usuario
 * @returns {boolean} true si está online
 */
export function isOnline() {
  return navigator.onLine;
}

/**
 * Escuchar cambios en el estado de conexión
 * @param {Function} callback - Ejecutar cuando cambie el estado
 * @returns {Function} Función para desuscribir
 */
export function onConnectionChange(callback) {
  const handleOnline = () => callback(true);
  const handleOffline = () => callback(false);

  window.addEventListener('online', handleOnline);
  window.addEventListener('offline', handleOffline);

  // Llamar inmediatamente con estado actual
  callback(navigator.onLine);

  // Retornar función de desuscripción
  return () => {
    window.removeEventListener('online', handleOnline);
    window.removeEventListener('offline', handleOffline);
  };
}
